import { createReducer } from '@reduxjs/toolkit';

import { StatisticsAssetInit } from 'redux/reducers/init';

import {
  requestStatisticsAsset,
  requestStatisticsAssetSuccess,
  requestStatisticsAssetFailure,
} from 'redux/actions/statistics/actions';

/**
 * Reducers
 */
const statisticsAsset = createReducer(StatisticsAssetInit, {
  [requestStatisticsAsset.type]: (state, action: RequestStatisticsAssetAction) => {
    state.isLoading = true;
  },
  [requestStatisticsAssetSuccess.type]: (state, action: RequestStatisticsAssetSuccessAction) => {
    const { statisticsAsset } = action.payload;
    state.isLoading = false;
    state.statistics = statisticsAsset;
  },
  [requestStatisticsAssetFailure.type]: (state, action: RequestStatisticsAssetFailureAction) => {
    state.isLoading = false;
    state.statistics = [];
  },
});

export default statisticsAsset;
